<template>
  <v-btn class="ml-2" fab x-small depressed :color="ledColor" :title="ledTitle">{{ ledText }}</v-btn>
</template>

<script>
  export default {
    props: {
      baseExpected: String,
      status: Object
    },
    data() {
      return {

      }
    },
    computed: {
      ledColor() {
        let colore = '#b5abab'
        if (this.status && this.status.health === '---') {
          colore = '#b5abab'
        } else if (this.status && this.status.health) {
          colore = 'green'
        } else if (this.status && !this.status.health) {
          colore = 'red'
        }
        if (this.status && this.status.conflicts && this.status.conflicts.length > 0) {
          colore = '#f1f436'
        }
        // if (this.status.baseDb !=='' && this.baseExpected !== this.status.baseDb) {
        //   colore = '#f1f436'
        // }
        return colore
      },
      ledText() {
        const testo = (this.status && this.status.modulo && this.status.modulo.substring(0, 2)) || ''
        return testo.toLowerCase()
      },
      ledTitle() {
        const testo = (this.status && this.status.modulo) || ''
        return testo.toLowerCase()
      }
    }
  }
</script>
